import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f9031f62: FaireBrandEntity = {
  token: "b_f9031f62",
  type: "brand",
  name: "Ware of the Dog",
  avatarUrl: "https://cdn.faire.com/fastly/256149146e85156132cdd2651ca498450fa32261da72174637fb53a20eef135b.png",
  bannerUrl: "https://cdn.faire.com/fastly/d869d36321add0324132309b3dc53a5651487d9c5bed30e9504de74ebc7db9b6.png",
  logoUrl: "https://cdn.faire.com/fastly/256149146e85156132cdd2651ca498450fa32261da72174637fb53a20eef135b.png",
  heroImageUrl: "https://cdn.faire.com/fastly/d869d36321add0324132309b3dc53a5651487d9c5bed30e9504de74ebc7db9b6.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 37,
  isInsider: true,
  description: "Ware of the Dog is a luxury dog accessory collection created by Jackie Rosenthal. The collection represents a high level of design and craft. The name of the collection and signature safety orange accent is inspired by Beware of the Dog signs found on many of your neighbor's fences here in New York City. Th pieces in the collection imbue this sense of humor and graphic sensibility. \n\nThe collection is available at high-end fashion, lifestyle and pet stores in the US and abroad, as well as on our web store. Ware of the Dog works with artists and craftsmen to create special one-of-a-kind items designed exclusively for the collection.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:04.540Z",
    importedBy: "entity-db-cli"
  }
};
